import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Grid,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { API_URL } from "../consts";
import { useState } from "react";
import { useSnackbar } from "notistack";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { Link as RouterLink } from "react-router-dom";

interface ForgotPasswordDto {
  email: string;
}
const schema = yup
  .object({
    email: yup.string().email().label("Email").required(),
  })
  .required();

export function ForgotPassword() {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useMutation(
    (data: ForgotPasswordDto) => {
      return axios.post(API_URL + "auth/passwordReset", data);
    },
    {
      onSuccess: () => {
        handleClickOpen();
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<ForgotPasswordDto>({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: ForgotPasswordDto) => {
    mutate(data);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Recupero password
        </Typography>

        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 2 }}>
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                required
                fullWidth
                type="email"
                label="Email"
                autoComplete="email"
                error={Boolean(errors.email)}
                helperText={errors.email?.message ?? " "}
              />
            )}
          />

          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Recupera Password
          </Button>
        </Box>

        <Grid container>
          <Grid item xs>
            <Link to="/login" variant="body2" component={RouterLink}>
              Login
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Email Inviata</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ti è stata inviata una email a {getValues("email")} contenente il link per cambiare
            password.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
